import { useTranslation } from 'react-i18next';

interface SectionTitleProps {
  title: string;
}

const SectionTitle = ({ title }: SectionTitleProps) => {
  const { t } = useTranslation();

  return (
    <div className={`pk-m--0 pk-mt--xs pk-mt-md--m ${title} pk-text--text-01 pk-font--comp-regular`}>
      {t('head_to_head')}
    </div>
  );
};

export default SectionTitle;
